export const environment = {
  indexable: false,
  ga4MeasurementId: '',
};
